import { render, staticRenderFns } from "./registerIndex.vue?vue&type=template&id=f359ebc4"
import script from "./registerIndex.vue?vue&type=script&lang=js"
export * from "./registerIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports